import './SltPrint.scss';

let clearActivePrint: (() => void) | undefined;

/** Print only the report, outside fixed/scrolling application and modal ancestors. */
export function printSltReport(button: HTMLElement): void {
  const source = button.closest('.sli-printSummary, .sls-print');
  if (!source) return;
  if (clearActivePrint) clearActivePrint();

  const root = document.createElement('div');
  root.className = 'sli-printRoot';
  const report = source.cloneNode(true) as HTMLElement;
  report.querySelectorAll('button, details, .sli-help, .sli-printExclude').forEach(element => element.remove());
  report.removeAttribute('id');
  report.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
  root.appendChild(report);
  document.body.appendChild(root);
  document.body.classList.add('sli-printing');
  const media = window.matchMedia('print');
  const leavePrint = (event: MediaQueryListEvent) => {
    if (!event.matches) cleanup();
  };
  const cleanup = () => {
    root.remove();
    document.body.classList.remove('sli-printing');
    window.removeEventListener('afterprint', cleanup);
    media.removeEventListener('change', leavePrint);
    if (clearActivePrint === cleanup) clearActivePrint = undefined;
  };
  clearActivePrint = cleanup;
  window.addEventListener('afterprint', cleanup);
  media.addEventListener('change', leavePrint);
  try {
    window.print();
  } catch (error) {
    cleanup();
    throw error;
  }
}
